import React from 'react';
import SEOHead from '../components/SEOHead';
import {
  Header,
  Hero,
  About,
  Services,
  Reviews,
  Gallery,
  Contact,
  Footer,
  WhatsAppButton
} from '../components/sections';

const Home = () => {
  return (
    <div className="bg-zinc-950 text-white">
      <SEOHead />
      <Header />
      <Hero />
      <About />
      <Services />
      <Reviews />
      <Gallery />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
